import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className="footer">
      <span>© 2022 — 2026 K Capital Technology Pty Ltd.</span>
      <span className="footer__center">ISO 27001 · SOC 2 Type II · Sydney · Dubai</span>
      <span className="footer__right">ABN 67 645 219 803 — Australia</span>
    </div>
  );
}
